// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-form-item[data-v-55c0f012]{width:17.1875rem}.content[data-v-55c0f012]{display:flex;align-items:center;justify-content:center;flex-direction:column;min-height:9.375rem}.content .right[data-v-55c0f012]{width:100%;display:flex;flex-direction:row-reverse}", ""]);
// Exports
module.exports = exports;
